module.exports = __webpack_public_path__ + "static/img/3_1_1.fa2c60e7.jpg";